module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/classifications/classifications-show/classifications-show.component.scss
// module id = ./src/app/views/setting/classifications/classifications-show/classifications-show.component.scss
// module chunks = main